
import {
  put, call, takeLatest,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { aGetEarlyPayoutSettingsRequest } from '../reducers';
import { aGetEarlyPayoutSettingsSuccess, aUpdateEarlyPayoutSettings, aUpdateEarlyPayoutSettingsSuccess } from '../reducers/earlyPayoutSettings';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';

/**
 * @memberof sagas/earlyPayoutSettings
 * @async
 */
function* getEarlyPayoutSettingsSaga() {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_EARLY_PAYOUT_SETTINGS,
      value: true,
    }));

    response = yield call(requestGet, API_URLS.GET_EARLY_PAYOUT_SETTINGS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetEarlyPayoutSettingsSuccess({
        earlyPayoutConfigurations: response.data.earlyPayoutConfigurations,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_EARLY_PAYOUT_SETTINGS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_EARLY_PAYOUT_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateEarlyPayoutSettingsSaga(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_EARLY_PAYOUT_SETTINGS,
      value: true,
    }));

    const config = [...action.payload?.marketDetails?.map((marketDetail) => ({
      marketId: marketDetail?.marketId,
      threshold: Number(marketDetail?.threshold),
      enabled: marketDetail?.enabled,
      minimumSlot: Number(marketDetail?.minimumSlot) || 0,
    }))];

    const data = {
      competitionId: action.payload?.competitionId,
      config,
    };

    response = yield call(requestPost, API_URLS.UPDATE_EARLY_PAYOUT_SETTINGS, data, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aUpdateEarlyPayoutSettingsSuccess({
        earlyPayoutConfigurations: response.data.earlyPayoutConfigurations,
      }));

      yield put(aSetOpenModal({
        modal: MODALS.SUCCESS,
        modalData: {
          message: SUCCESS_MODALS.UPDATE_EARLY_PAYOUT_SETTINGS,
          additionalMessage: 'successfully',
          modal: SUCCESS_MODALS.UPDATE_EARLY_PAYOUT_SETTINGS,
        },
      }));

      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.UPDATE_EARLY_PAYOUT_SETTINGS,
        value: false,
      }));
    }
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_EARLY_PAYOUT_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/earlyPayoutSettings
 * @async
 * @returns {void}
 */
export default function* earlyPayoutSettingsSaga() {
  yield takeLatest(aGetEarlyPayoutSettingsRequest, getEarlyPayoutSettingsSaga);
  yield takeLatest(aUpdateEarlyPayoutSettings, updateEarlyPayoutSettingsSaga);
}

